import { wareHouseApi } from './modiuesLX/wareHouse'
import { materialFormApi } from './modiuesLX/materialForm'
import { inspectionApi } from './modiuesLX/inspection'
export const APILX = {
  ...wareHouseApi,
  ...materialFormApi,
  ...inspectionApi,
}

// import { APILX } from '@/api/requestLx'